<template>
    <div class="edit-note-widget">
        <div class="note-top-header">
            <div class="note-title-section">
                <div class="note-title">
                    <h2>{{ note_item.title }}</h2>
                </div>
            </div>
            <div class="note-actions">
                <button class="action-btn edit" @click="editNote()">
                    <img src="@/assets/icons/notes/pencil.svg" alt="edit" />
                </button>
                <button v-if="false" class="action-btn share">
                    <img src="@/assets/icons/share-forward.svg" alt="share" />
                </button>


                <widgetDropdown v-model="toggle_more_action" :right="true" :hover="false" :interactive="true">
                    <button class="action-btn more">
                        <img src="@/assets/icons/more.svg" alt="more" />
                    </button>
                    <div slot="dropdown" class="dropdown-widget right">
                        <app-dialog title="Delete Note" ask="Are you sure you want to delete this note?"
                            yesText="Delete" noText="Cancel" @onComfirm="deleteNote()">
                            <button class="dropdown-item">
                                Delete
                            </button>
                        </app-dialog>
                    </div>
                </widgetDropdown>
            </div>
        </div>
        <div class="note-header" v-if="false"> </div>
        <div class="note-details">
            <div class="detail-item">
                <span class="label">
                    <img src="@/assets/icons/notes/calendar.svg">
                    Date</span>
                <span class="value">{{ new Date(note_item.created_at).toLocaleDateString('en-US', {
                    day: 'numeric',
                    month: 'long', year: 'numeric'
                }) }}</span>
            </div>

            <div class="detail-item" v-if="note_item.contacts">
                <span class="label">
                    <img src="@/assets/icons/notes/user.svg">
                    Contacts</span>
                <div class="people-list">
                    <div class="person" v-for="(person, index) in note_item.contacts" :key="index">
                        <widgetProfile :title="person.first_name + ' ' + person.last_name" :size="18" :text_size="6"
                            :subtitle="''" :file_name="null" :path="$fullUrl('images/profiles/')"></widgetProfile>
                    </div>
                    <div class="no-people" v-if="!note_item.contacts.length">
                        <span>No contacts added</span>
                    </div>
                    <button v-if="false" class="add-person">Add a contact <img
                            src="@/assets/icons/notes/user-add.svg"></button>
                </div>
            </div>

            <div class="detail-item" v-if="note_item.people">
                <span class="label">
                    <img src="@/assets/icons/notes/user.svg">
                    Responsible</span>
                <div class="people-list">
                    <div class="person" v-for="(person, index) in note_item.people" :key="index">
                        <widgetProfile :title="person.first_name + ' ' + person.last_name" :size="18" :text_size="6"
                            :subtitle="''" :file_name="null" :path="$fullUrl('images/profiles/')"></widgetProfile>
                    </div>
                    <div class="no-people" v-if="!note_item.people.length">
                        <span>No responsible added</span>
                    </div>
                    <button v-if="false" class="add-person">Add a responsible <img
                            src="@/assets/icons/notes/user-add.svg"></button>
                </div>
            </div>


            <div class="note-editor">
                <span class="label">
                    <img src="@/assets/icons/notes/description.svg">
                    Description</span>
                <html-editor placeholder="Enter your notes" v-model="noteContent" @input="onNoteContentChange"
                    class="notes-editor-widget" id="edit-descr" />
            </div>

            <div class="note-attachments">
                <h3> <img src="@/assets/icons/notes/attachment.svg"> Attachment ({{ attachments.length }})</h3>
                <div class="attachment-list">
                    <div class="attachment-item" v-for="(file, index) in attachments" :key="index">
                        <div class="file-info">
                            <div class="file-type">{{ getFileExtension(file) }}</div>
                            <div class="file-details">
                                <span class="file-name">{{ file }}</span>
                                <span class="file-meta"> {{ moment(note_item.created_at).format('DD/MM/YYYY') }}</span>
                            </div>
                        </div>
                        <div class="file-actions">
                            <button class="download-btn" @click=" downloadAttachment({ id: null, document: file })">
                                <img src="@/assets/icons/notes/download.svg" alt="download" />
                            </button>
                            <button class="delete-btn" @click="removeFile(file, index)">
                                <img src="@/assets/icons/notes/trash.svg" alt="delete" />
                            </button>
                        </div>
                    </div>
                    <input type="file" ref="fileInput" @change="handleFileUpload" style="display: none" />
                    <button class="upload-btn" @click="$refs.fileInput.click()">
                        Upload file
                        <img src="@/assets/icons/notes/upload.svg">
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EditNoteWidget',
    props: {
        note_item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            noteContent: '',
            attachments: [],
            saveTimer: null,
            toggle_more_action: false
        }
    },
    mounted() {
        this.noteContent = this.note_item.content;
        this.attachments = this.note_item.attachments || [];
    },
    watch: {
        note_item: {
            deep: true,
            handler(newVal) {
                this.noteContent = newVal.content;
                this.attachments = newVal.attachments || [];
            }
        }
    },
    methods: {
        removeFile(file, index) {
            let vm = this;
            vm.$store.dispatch("NOTES_DELETE_ATTACHMENT", {
                note_id: vm.note_item.id,
                attachment_name: file
            }).then(() => {
                vm.attachments.splice(index, 1);
                vm.$notify({
                    title: 'Success',
                    message: 'Attachment deleted successfully',
                    type: 'success'
                });
            }).catch((error) => {
                vm.$notify({
                    title: 'Error',
                    message: 'Failed to delete attachment',
                    type: 'error'
                });
            });
        },
        downloadAttachment(item) {
            let vm = this;
            vm.$store
                .dispatch("ACCOUNT_SINGLE_ATTACHMENT_DOWNLOAD_FILE", {
                    id: item.id,
                    name: item.document,
                    type: 'note'
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", item.document); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => console.log(error));
        },
        deleteNote() {
            let vm = this;
            vm.$emit('deleteNote', vm.note_item);
        },
        editNote() {
            let vm = this;
            vm.$emit('editNote', vm.note_item);
        },
        onNoteContentChange(content) {
            let vm = this;
            if (vm.saveTimer) {
                clearTimeout(vm.saveTimer);
            }
            vm.saveTimer = setTimeout(() => {
                vm.$emit('noteContentChange', content);
            }, 1000);
        },
        handleFileUpload(event) {
            let vm = this;
            const file = event.target.files[0];
            if (file) {
                // Reset the input so the same file can be uploaded again if needed
                event.target.value = '';
                const formData = new FormData();
                formData.append('id', vm.note_item.id);
                formData.append('file', file);

                vm.$store.dispatch("NOTES_UPLOAD_ATTACHMENT", formData)
                    .then((responce) => {
                        vm.attachments = responce.data.attachments;
                        vm.$emit('noteFileUploaded', file);
                        vm.$notify({
                            group: "status",
                            title: "Success",
                            text: "File uploaded successfully",
                            type: "success",
                            duration: 3000,
                        });
                    })
                    .catch((error) => {
                        vm.$notify({
                            group: "status",
                            title: "Success",
                            text: "Something went wrong, try again",
                            type: "warn",
                            duration: 3000,
                        });
                    });
            }
        },
        getFileExtension(filename) {
            return filename.split('.').pop().toUpperCase();
        },
    }
}
</script>

<style lang="scss" scoped>
.edit-note-widget {
    padding-bottom: 100px;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    height: 100%;
    overflow-y: auto;

    .note-top-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid rgba(180, 180, 180, 0.3);
        padding: 20px;

        .note-title-section {
            display: flex;
            align-items: center;

            .note-title {
                h2 {
                    font-size: 16px;
                    margin: 0;
                }
            }
        }

        .note-actions {
            display: flex;
            align-items: center;
            gap: 10px;

            .action-btn {
                background: none;
                border: none;
                cursor: pointer;
                border-radius: 4px;
                height: 20px;
                width: 20px;
                display: flex;
                align-items: center;
                justify-content: center;

                &:hover {
                    background: #f5f5f5;
                }
            }
        }
    }

    .note-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 20px;

        .note-title h2 {
            font-size: 16px;
            margin: 0;
        }


    }

    .note-details {
        display: flex;
        flex-direction: column;
        gap: 15px;
        padding: 0px 20px;

        .detail-item {
            display: flex;
            align-items: center;
            gap: 10px;

            .label {
                color: #666;
                width: 80px;
                display: flex;
                align-items: center;
                gap: 5px;
            }

            .status-completed {
                color: #4CAF50;
                display: flex;
                align-items: center;
                gap: 5px;

                &::before {
                    content: '';
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    background: #4CAF50;
                    border-radius: 50%;
                }
            }

            .people-list {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                gap: 10px;

                .person {
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    padding: 4px;
                    background: rgba(8, 132, 175, 0.1);
                    border-radius: 20px;

                    img {
                        width: 24px;
                        height: 24px;
                        border-radius: 50%;
                    }
                }

                .add-person {
                    border: 1px solid rgba(244, 244, 244, 1);
                    background: none;
                    color: #0884AF;
                    cursor: pointer;
                    padding: 4px 8px;
                    border-radius: 20px;
                    display: flex;
                    align-items: center;
                    gap: 5px;

                    &:hover {
                        background: rgba(8, 132, 175, 0.1);
                    }
                }
            }

            .notes-tags-widget {
                display: flex;
                flex-wrap: wrap;
                gap: 5px;

                .notes-tag {
                    background: rgba(8, 132, 175, 0.1);
                    padding: 4px 8px;
                    border-radius: 20px;
                    display: flex;
                    align-items: center;
                    gap: 5px;

                    .notes-tag-name {
                        font-size: 10px;
                    }
                }
            }
        }


        .note-editor {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            gap: 10px;

            .label {
                color: #666;
                width: 80px;
                display: flex;
                align-items: center;
                gap: 5px;
            }


            .notes-editor-widget {
                flex-grow: 1;
                border: 1px solid #ddd;
                border-radius: 4px;
                padding: 10px;
            }
        }

        .note-attachments {

            h3 {
                display: flex;
                align-items: center;
                gap: 5px;
                margin-bottom: 15px;
                color: rgba(175, 175, 175, 1);
                font-size: 12px;
                font-weight: normal;
            }

            .attachment-list {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 10px;

                .attachment-item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 10px;
                    border: 1px solid #ddd;
                    border-radius: 4px;

                    .file-info {
                        display: flex;
                        align-items: center;
                        gap: 10px;

                        .file-type {
                            background: #F44336;
                            color: white;
                            padding: 4px 8px;
                            border-radius: 4px;
                        }

                        .file-details {
                            display: flex;
                            flex-direction: column;

                            .file-meta {
                                color: #666;
                                font-size: 10px;
                            }
                        }
                    }

                    .file-actions {
                        display: flex;
                        gap: 10px;

                        button {
                            background: none;
                            border: none;
                            cursor: pointer;
                            padding: 4px;
                            border-radius: 4px;

                            &:hover {
                                background: #f5f5f5;
                            }
                        }
                    }
                }

                .upload-btn {
                    display: flex;
                    align-items: center;
                    background: none;
                    border: 2px dashed #ddd;
                    border-radius: 4px;
                    cursor: pointer;
                    color: #666;
                    justify-content: center;
                    height: 40px;

                    &:hover {
                        background: #f5f5f5;
                    }

                    img {
                        width: 14px;
                        margin-left: 8px;
                    }
                }
            }

        }
    }
}
</style>
